import React from 'react'

const GetStarted = () => {
  return (
    <>
      <h1 className="text-center font-semibold text-3xl my-4">Pricing</h1>

      <section className="mx-3">
        <div className="bg-blue-200 p-3 rounded shadow-lg mb-5">
          <h3 className="font-semibold mb-1 text-xl">CCTV Installations</h3>
          <ul>
            <li>Lorem ipsum dolor sit.</li>
            <li>Lorem ipsum dolor sit.</li>
            <li>Lorem ipsum dolor sit.</li>
          </ul>
          <p className="font-semibold mt-3 text-xl">Ksh. 10,000 per month</p>
        </div>

        <div className="bg-blue-200 p-3 rounded shadow-lg mb-5">
          <h3 className="font-semibold mb-1 text-xl">
            Round the clock security
          </h3>
          <ul>
            <li>Lorem ipsum dolor sit.</li>
            <li>Lorem ipsum dolor sit.</li>
            <li>Lorem ipsum dolor sit.</li>
          </ul>
          <p className="font-semibold mt-3 text-xl">Ksh. 15,000 per month</p>
        </div>

        <div className="bg-blue-200 p-3 rounded shadow-lg mb-5">
          <h3 className="font-semibold mb-1 text-xl">Patrol Vehicles</h3>
          <ul>
            <li>Lorem ipsum dolor sit.</li>
            <li>Lorem ipsum dolor sit.</li>
            <li>Lorem ipsum dolor sit.</li>
          </ul>
          <p className="font-semibold mt-3 text-xl">Ksh. 20,000 per month</p>
        </div>
      </section>
    </>
  )
}

export default GetStarted
